<template>
  <slot name="header_close" />
  <div class="success-container">
    <i class="fa fa-check-circle-o fa-xl"></i>
    <p
      class="info"
      v-html="
        $t('dialog.activation_success.text', {
          number:
            $props.number ||
            $store.state.dialogParams?.info?.number ||
            $store.state.dialogParams?.number ||
            $route.params?.number ||
            $store.state.dialogParams,
        })
      "
    ></p>
  </div>
</template>

<script>
export default {
  name: "SuccessActivationDialog",
  props: {
    number: {
      type: String,
      required: true,
    },
  },
  // !TODO: определить конечную точку вывода номера(стейт, пропс, параметр)
  mounted() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "success_number_activation",

      number:
        this.$props.number ||
        this.$store.state.dialogParams?.info?.number ||
        this.$store.state.dialogParams?.number ||
        this.$route.params.number,
    });
  },
};
</script>

<style lang="scss" scoped>
.success-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 24px;
  font-family: Gilroy;
  font-size: 24px;
  font-weight: 500;
  color: var(--text-color);
  background-color: white;
  padding: 40px 20px;
  border-radius: 7px;

  .fa {
    color: var(--success-color);
    font-size: 300%; //72px
    background: var(--block-color);
    border-radius: 15px;
    padding: 7px 10px;
  }

  @media screen and (max-width: 420px) {
    flex-direction: column;
    align-items: center;

    .fa {
      font-size: 100px;
    }

    .info {
      width: 100%;
      text-align: center;
    }
  }
}

.info {
  margin-top: 10px;
  color: black;
}
</style>
